<template>
  <div id="slide_box" class="slide1">
    <div id="slide_content" :style="{background: color}">
      <div class="slide_block" id="slide1" :class="getShowClass()">
         <div class="slide_animate_block">
          <div class="bg" :style="{background: color}">
            <div class="wrap01">
              <h2 class="stitle"><span>回収先住所を</span><br><span>入力してください。</span></h2>
              <CommonErrorMsgArea />
              <div class="form_block_zip">
                <p class="icon">〒</p>
                <p class="zip_input_01"><input type="number" name="zip1" class="form-InputText" placeholder="" id="zip1" pattern="\d*"
                 v-model="postcode.firstPickupZipcode.value" maxlength="3" @change="clear" @input="inputActions(postcode.firstPickupZipcode, $event)"></p>
                <p class="hyphen"></p>
                <p class="zip_input_02"><input type="number" name="zip2" class="form-InputText" placeholder="" id="zip2" pattern="\d*"
                 v-model="postcode.lastPickupZipcode.value" maxlength="4" @change="clear" @input="inputActions(postcode.lastPickupZipcode, $event)"></p>
                <p class="zip_btn"><button type="button" class="form-Button-01" :style="{backgroundColor : searchAddressColor}" @click="serchAddress">住所検索</button></p>
              </div>
              <p class="error" v-if="error.invalid_pickupZipcode">{{$msg.ERROR.MSG_0001}}</p>
              <p class="error" v-if="error.invalid_collectionArea && addressList.length == 0">{{$msg.ERROR.MSG_0002}}</p>
              <p class="error" v-if="error.invalid_collectionArea && addressList.length > 0">{{$msg.ERROR.MSG_0022}}</p>
               <p class="error" v-if="error.nodata_pickupZipcode">{{$msg.ERROR.MSG_0021}}</p>
              <p id="zip_message" class="">該当住所を選択・入力してください。</p>
              <div class="form_block_01">
                <p v-if='selected && addressList.length == 1' id="address_text_01">{{ selected.label }}</p>
                <div v-if='addressList.length >= 2' class="form-Radio-02" id="address_radio">
                  <label v-for="selectAddress in addressList" :key="selectAddress.code">
                    <input type="radio" name="address_radio" v-model="selected" :value="selectAddress" @change="checkAddress">
                    <span class="input_txt" :style="{backgroundColor :selectAddress.code == selected.code? selectedColor:''}" :class="{'invalid': selectAddress.isNgArea, 'selected' : selectAddress.code == selected.code}">{{ selectAddress.label }}</span></label>
                    <p class="error" v-if="error.invalid_selected">{{$msg.ERROR.MSG_0003}}</p>
                </div>

                <p class="address_text"><input type="text" name="address1" class="form-InputText" placeholder="例）1-1-1" id="address1"
                 v-model="addresses.address" maxlength="30"></p>
                <p class="error" v-if="error.required_address">{{$msg.ERROR.MSG_0004}}</p>
                <p class="error" v-if="error.invalid_address">{{$msg.ERROR.MSG_0023}}</p>
                <p class="address_text"><input type="text" name="address2" class="form-InputText" placeholder="例）〇〇マンション101号" id="address2"
                 v-model="addresses.buildingName" maxlength="30"></p>
                <p class="error" v-if="error.invalid_buildingName">{{$msg.ERROR.MSG_0024}}</p>
              </div>
              <p class="next_page"><button type="button" class="form-Button-01 move_slide" :style="{backgroundColor : nextPageColor}" data-toslide="slide2" @click="submitAddressForm" :disabled="disableFlg">回収品目の入力へ進む</button></p>
            </div>
          </div>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddressForm from '../../js/AddressForm'
import CommonErrorMsgArea from '@/components/sp/CommonErrorMsgArea'


export default {
  props: {
    siteCodeInfo: Array,
    siteCodeItem: Array,
    compItems: Object
  },
  data() {
    return {
      addressList: [],
      selected: '',
      addresses: {
        pickupPref: '',
        address: '',
        buildingName: ''
      },
      postcode: {
        firstPickupZipcode: {value:''},
        lastPickupZipcode: {value:''}
      },
      error: {
        invalid_pickupZipcode: false,
        invalid_address: false,
        required_address: false,
        invalid_buildingName: false,
        invalid_selected: false,
        invalid_collectionArea: false,
        nodata_pickupZipcode : false
      },
      hasItems: true
    }
  },
  watch: {
    siteCodeItem: function (val) {
      AddressForm.setDisplayItems(this, val)
      AddressForm.updateHasItems(this)
    }
  },
  computed: {
    color: AddressForm.getColor,
    searchAddressColor: AddressForm.getSearchAddressColor,
    nextPageColor: AddressForm.getNextPageColor,
    selectedColor: AddressForm.getSelectedColor,
    disableFlg: AddressForm.getDisableFlg,
  },
  created() {
    //入力保持
    AddressForm.inputRetention(this)
  },
  methods: {
    clear() {
      AddressForm.clear(this)
    },
    inputActions(zipCodePart, e){
      AddressForm.inputActions(this, zipCodePart, e)
    },
    serchAddress() {
      AddressForm.serchAddress(this)
    },
    checkAddress() {
      AddressForm.checkAddress(this)
    },
    submitAddressForm() {
      AddressForm.submitAddressForm(this)
    }
  },
    components: { CommonErrorMsgArea }
}
</script>
